import * as types from '../actions/actionTypes';
import initialState from './initialState';

function updateNickname(items, policy) {
    const existing = items.find(item => item.id === policy.id);
    existing.nickname = policy.nickname;
    return items;
}

export default function policyReducer (state=initialState.policy, action) {
    switch (action.type) {
        case types.POLICY__UPDATE_NEW_POLICY:
            return {...state, add: action.policy};
        case types.POLICY__CLEAR_NEW_POLICY:
            return {...state, add: {...initialState.policy.add}, edit: {...initialState.policy.edit}};
        case types.POLICY__ADD_REQUEST:
            return {...state, add: {...state.add, loading: true}};
        case types.POLICY__ADD_SUCCESS:
            return {...state, add: {...initialState.policy.add}};
        case types.POLICY__ADD_FAILURE:
            return {...state, add: {...state.add, loading: false, error: action.error}};
        case types.POLICY__GET_SUCCESS:
            return {...state, items: action.response.policies, loaded: true };
        case types.POLICY__EDIT_NICKNAME_REQUEST:
            return {...state, edit: initialState.policy.edit};
        case types.POLICY__EDIT_NICKNAME_FAILURE:
            return {...state, edit: {loading: false, error: action.error}};
        case types.POLICY__EDIT_NICKNAME_SUCCESS:
            return {...state, items: updateNickname(state.items, action.payload.policy), edit: initialState.policy.edit};
        case types.LOGOUT__USER_SUCCESS:
            return {...initialState.policy};
        default:
            return state;
    }
}